<template>
  <div class="mxMobileContent">
    <div class="title">{{ $t("mxHarmonyTitle") }}</div>
    <div class="desc">{{ $t("mxLongContent") }}</div>
    <div class="code-container">
      <!-- hormonyosCode -->
      <canvas ref="hormonyosCode"></canvas>
      <img
        class="mxScanIcon"
        src="../assets/downloadImg/logo2.png"
        style="margin-top: -7.5px;"
        alt=""
      />
    </div>
    <div class="scan-hint">{{ $t("mx.scanCodeDown") }}</div>
    <div class="harmony-download" @click="toDownload">{{ $t("mx.downloadClick") }}</div>
    <div class="add-group" @click="openAddGroupTips">{{ $t("mx.hormony_group") }}</div>
    
    <el-dialog
      :title="$t('mx.hormony_group')"
      :visible.sync="dialogVisible"
      width="80%">
      <div class="dialog_content">
        <div class="qrcode_group">
          <img
            class="group-code"
            src="../assets/downloadImg/harmony-group.png"
            alt=""
          />
          <img class="qrcode_icon" src="../assets/downloadImg/logo2.png" alt="" />
        </div>
        <div class="tips">{{ $t('mx.harmonyScan') }}</div>
        <div class="group-num">
          <div>{{ groupNum }}</div>
          <img
            class="copy-btn"
            src="../assets/downloadImg/copy.png"
            @click="onCopy"
          />
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import QRCode from "qrcode";
import CopyGroupnumber from "./js/copy-groupnumber";
import { getApiConfig } from "@/mx-service/libs/http/config";
export default {
  mixins: [CopyGroupnumber],
  data(){
    return {
      hormonyOSCodeData: getApiConfig().hormonyOSDownloadUrl,
      dialogVisible: false,
      qrHormonyCodeOptions: {
        width: 183,
        height: 183,
      },
    }
  },
  methods: {
    toDownload() {
      const userAgent = window.navigator.userAgent;
      if(userAgent.toLowerCase().includes('mideaConnect')) {
        mx.openSysBrowser([this.hormonyOSCodeData]).then(function (success) {
          console.log(success);
        })
      } else {
        window.location.href = this.hormonyOSCodeData;
      }
    },
    openAddGroupTips(){
      this.dialogVisible = true
    }
  },
  mounted(){
    QRCode.toCanvas(
      this.$refs.hormonyosCode,
      this.hormonyOSCodeData,
      this.qrHormonyCodeOptions,
      function (error) {
        if (error) console.error(error)
      }
    );
  }
};
</script>
<style lang="less" scoped>
.mxMobileContent {
  padding-top: 100px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  .title {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #191919;
    line-height: 48px;
  }
  .desc {
    margin-top: 4px;
    font-size: 16px;
    color: #666666;
    line-height: 24px;
  }
  .code-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 36px;

    .harmony-code {
      height: 160px;
      width: auto;
      object-fit: scale-down;
    }
    .mxScanIcon {
      width: 44px;
      height: 44px;
      position: absolute;
      background: #fff;
      z-index: 50;
    }
  }
  // .qrcode_download {
  //   margin-top: 28px;
  //   position: relative;
  //   z-index: 49;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   padding: 10px;
  //   background-color: #ffffff;
  //   .group-code {
  //     width: 156px;
  //     height: auto;
  //     object-fit: scale-down;
  //   }
  //   .qrcode_icon {
  //     position: absolute;
  //     z-index: 50;
  //     width: 46px;
  //     height: 46px;
  //   }
  // }
  .qrcode_group {
    position: relative;
    z-index: 49;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    background-color: #ffffff;
    border: 2px solid #F5F5F5;
    border-radius: 12px;

    .group-code {
      width: 156px;
      height: auto;
      object-fit: scale-down;
    }
    .qrcode_icon {
      position: absolute;
      z-index: 50;
      width: 46px;
      height: 46px;
    }
  }
  .scan-hint {
    line-height: 22px;
    text-align: center;
    color: #191919;
    margin-top: 12px;
    // font-family: 苹方-简;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0px;
    opacity: 0.8738;
  }
  .harmony-download {
    padding: 9px 112px;
    background: #2496FF;
    border-radius: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: 500;
    line-height: 26px;
    letter-spacing: 0px;
    color: #FFFFFF;
    margin-top: 24px;
  }
  .add-group {
    font-size: 14px;
    font-weight: normal;
    line-height: 22px;
    text-align: center;
    letter-spacing: 0px;
    margin-top: 12px;
    /* 功能色/信息/信息3_主色 */
    color: #2496FF;
  }
  .group-hint {
    line-height: 24px;
    text-align: center;
    color: #666666;
    margin-top: 24px;
  }
  .group-num {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 4px;
    color: #666666;
    line-height: 24px;
    .copy-btn {
      margin-left: 12px;
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
  }
}
.el-dialog {
  border-radius: 20px !important;
  .dialog_content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
  .tips {
    white-space: pre-wrap;
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    text-align: center;
    letter-spacing: 0px;
    /* 中性灰/灰色7_主要文字 */
    color: #191919;
    margin-bottom: 24px;
  }
}
</style>

<style lang="less">
.mxMobileContent .el-dialog {
  border-radius: 20px !important;
}
</style>
